module.exports = __webpack_public_path__ + "img/coat_of_arms_of_nigeria.9900a9e8.png";